import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Box from '../../Box';
import Tools from '../../Tools';

const ClientHeader = (props) => {

    const [client, setClient] = useState(props.client);

    const [phoneList, setPhoneList] = useState([]);
    const [childrenVisible, setChildrenVisible] = useState(false);
    const [addingPhoneToClient, setAddingPhoneToClient] = useState(false);
    const [toggleEditMail, setToggleEditMail] = useState(true);
    const [toggleEditPhone, setToggleEditPhone] = useState(true);
    const [data, setData] = useState({});

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const saveChangesClient = (fieldToChange, fieldNewValue, restoreBoxMethod) => {

        if (fieldNewValue) {

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/client`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: {
                    clientId: props.client._id,
                    fieldToChange: fieldToChange,
                    fieldNewValue: fieldNewValue
                }
            };

            axios(options).then(response => {
                if (response.data.error === null) {
                    //update client object (from parent)
                    let updatedClient = Object.assign({}, props.client);
                    if (String(fieldToChange).indexOf(".") !== -1) {
                        let splittedKey = String(fieldToChange).split(".");
                        updatedClient[splittedKey[0]][splittedKey[1]] = fieldNewValue;
                    } else {
                        updatedClient[fieldToChange] = fieldNewValue;
                    }

                    updatedClient.random = new Date().valueOf();
                    props.updateClientMethod(updatedClient);
                    restoreBoxMethod(true);
                }
            });

        } else {
            restoreBoxMethod(true);
        }

    }

    const addPhoneToClient = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientPhones`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                clientId: props.client.clientId,
                assignmentId: props.campaign.assignmentId,
                availablePhoneNumber: getAvailablePhoneNumber(),
                phoneNumberToAdd: data.phoneNumberToAdd
            }
        };

        axios(options).then(response => {
            if (response.data.error === null) {
                //update client object (from parent)
                let updatedClient = Object.assign({}, props.client);
                updatedClient.contacto[getAvailablePhoneNumber()] = data.phoneNumberToAdd;
                props.updateClientMethod(updatedClient);

                let backupNewPhone = data.phoneNumberToAdd;

                //update visually in current component
                const clonedPhoneList = [...phoneList];
                clonedPhoneList.push(data.phoneNumberToAdd);
                setPhoneList(clonedPhoneList);

                data.phoneNumberToAdd = undefined;
                setAddingPhoneToClient(false);

                //after save new phone, if client only have ONE phone, set new phone as selected
                if (clonedPhoneList.length === 1) {
                    let updatedClient = Object.assign({}, props.client);
                    updatedClient.currentPhone = backupNewPhone;
                    props.updateClientMethod(updatedClient);
                    setChildrenVisible(false);
                }
            }
        });

    }

    const Popover = (props) => {
        if (props.show) {
            return <div className={'popover ' + props.position} style={{ width: props.width }}>{props.children}</div>
        } else {
            return null;
        }
    }

    const getAvailablePhoneNumber = () => {
        let i = 1, available = false, availableNumber = 'telefono16';
        while (i <= 15 && !available) {
            let currentPhone = props.client.contacto[`telefono${i}`];
            if (currentPhone === undefined || currentPhone === null || currentPhone === "null" || currentPhone === "") {
                availableNumber = `telefono${i}`;
                available = true;
            }
            i++;
        }
        return availableNumber;
    }

    useEffect(() => {
        let phoneList = [], i = 1;
        while (i <= 15) {
            let currentPhone = props.client.contacto[`telefono${i}`];
            if (currentPhone && currentPhone !== null && currentPhone !== "null" && currentPhone !== "") {
                phoneList.push(currentPhone);
            }
            i++;
        }

        setPhoneList(phoneList);

        //SET DEFAULT CURRENTPHONE
        let updatedClient = Object.assign({}, props.client);
        if (props.phone) {
            updatedClient.currentPhone = props.phone;
        } else {
            updatedClient.currentPhone = Tools.getPriorityPhone(props.client.contacto);;
        }
        props.updateClientMethod(updatedClient);
    }, []);

    return (
        <div className="flexRow headerClient">
            <div className="flexCol">

                <Box type="readOnly" className="" name="clientId" label="clientId" value={client.clientId}></Box>

                <Box
                    type="readOnly"
                    fieldType="CONTENT"
                    className="x3"
                    name="clienteNombre"
                    label="Nombre"
                    value={client.clienteNombre + ' ' + client.clienteApPat + ' ' + client.clienteApMat}
                    placeholder="Ingrese nombre cliente"
                />

                <Box type="readOnly" className="worb" name="phone" label={'Teléfono (' + phoneList.length + ')'} labelClassName='phoneListTrigger' tooltipLabel="Teléfonos adicionales" value={props.client.currentPhone} showChildren={true} toggleChildrensVisible={() => setChildrenVisible(!childrenVisible)} childrenVisible={childrenVisible}>
                    <div className='phoneList'>
                        <ol>
                            {phoneList.map((phone, index) => {
                                return (
                                    <li className={phone === props.client.currentPhone ? 'selected' : undefined} key={index}><a onClick={() => { let updatedClient = Object.assign({}, props.client); updatedClient.currentPhone = phone; props.updateClientMethod(updatedClient); setChildrenVisible(!childrenVisible); }}>{phone}</a></li>
                                );
                            })}
                        </ol>
                        <hr className="sep" />
                        {!addingPhoneToClient ? (
                            <button onClick={() => setAddingPhoneToClient(true)}>Agregar Teléfono</button>) :
                            (<Fragment>
                                <input name="phoneNumberToAdd" className={data.phoneNumberToAdd && data.phoneNumberToAdd.length < 11 ? 'invalid' : 'valid'} placeholder="56900000000" maxLength={11} type="text" onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} onChange={handleChange} />
                                <div className="flexRow buttonGroup">
                                    <button disabled={!data.phoneNumberToAdd || (data.phoneNumberToAdd && data.phoneNumberToAdd.length < 11)} onClick={addPhoneToClient}>Aceptar</button>
                                    <button onClick={() => setAddingPhoneToClient(false)}>Cancelar</button>
                                </div>
                            </Fragment>
                            )}
                    </div>
                </Box>

                <Box type="readOnly" className="x3" name="currentEmail" label="Email registrado" value={client.contacto.correo} placeholder="Sin Email"></Box>
                {toggleEditMail ? (
                    <Box type="readOnly" fieldType="CONTENT" className="x3 editable" name="nuevoMail" label="Nuevo Email" value={client.nuevoMail} placeholder="Ingrese nuevo email" onDoubleClick={() => setToggleEditMail(!toggleEditMail)}></Box>
                ) : (
                    <Box type="text+content" name="nuevoMail" label="Nuevo email" className="x3" placeholder="Ingrese nuevo email" value={client.nuevoMail} onChange={handleChange} inputOnBlur={() => saveChangesClient("nuevoMail", data.nuevoMail, setToggleEditMail)}></Box>
                )}

                {toggleEditPhone ? (
                    <Box type="readOnly" fieldType="CONTENT" className="editable" name="nuevoTelefono" label="Nuevo Teléfono" value={client.nuevoTelefono} placeholder="Ingrese nuevo Teléfono" onDoubleClick={() => setToggleEditPhone(!toggleEditPhone)}></Box>
                ) : (
                    <Box type="text+content" name="nuevoTelefono" label="Nuevo Teléfono" className="" placeholder="Ingrese nuevo Teléfono" value={client.nuevoTelefono} onChange={handleChange} inputOnBlur={() => saveChangesClient("nuevoTelefono", data.nuevoTelefono, setToggleEditPhone)}></Box>
                )}

            </div>
        </div>
    );

}

export default ClientHeader;
